import { useDispatch, useSelector } from "react-redux";
import { downloadWeeklyProductExcel } from "../thunks/downloadWeeklyProductReportExcel";
import React from "react";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";

export const useWeeklyProductExcelDownloader = () => {
  const fetchState = useSelector<StoreType, FetchStateType>(
    (s) => s.data.reports.weeklyTrade.downloadReportFetchState
  );

  const dispatch = useDispatch();
  const download = React.useCallback(
    () => dispatch(downloadWeeklyProductExcel()),
    [dispatch]
  );

  return [download, fetchState] as [typeof download, typeof fetchState];
};
